import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';

import AppWrapper from './AppWrapper';

import { HashRouter } from 'react-router-dom'

import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxCatch from 'redux-catch';

function errorHandler(error, getState, lastAction, dispatch) {
    console.error(error);
    console.debug('current state', getState());
    console.debug('last action was', lastAction);
    // optionally dispatch an action due to the error using the dispatch parameter
  }

  const reduxCatchh  = reduxCatch(errorHandler)

  //const middlewares = [reduxCatchh, thunk]
  //const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);

  const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);
//import * as serviceWorker from './serviceWorker';

  ReactDOM.render(
    <HashRouter>
        <Provider store={createStoreWithMiddleware(reducers,composeWithDevTools( ))}>
            <AppWrapper />
        </Provider>
    </HashRouter>,
    document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();


